<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
        <div class="container">
            <h2 class="marathi-font" [innerHTML]="title"></h2>
        </div>
    </div><!-- End Breadcrumbs -->

    <section id="testimonials1">
        <div class="container" data-aos="fade-up">

            <!-- <div class="section-title pb-0">
                <h2>Read Online</h2>
                <p class="marathi-font" [innerHTML]="title"></p><br>
            </div> -->
            <div class="row" *ngIf="isSutraPath">
                <div class="col-3">
                    <div class="nav flex-column nav-pills me-3 marathi-font" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link"  routerLink="/path/sutrapath/nauprakaran" id="v-pills-home-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home"
                            aria-selected="true">नवप्रकरण</a>
                        <a class="nav-link"   routerLink="/path/sutrapath/achar"  id="v-pills-profile-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile"
                            aria-selected="false">आचार</a>
                        <a class="nav-link"  routerLink="/path/sutrapath/acharMalika"  id="v-pills-messages-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages"
                            aria-selected="false">आचार
                            मालिका</a>
                        <a class="nav-link"  routerLink="/path/sutrapath/vichar"  id="v-pills-messages-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages"
                            aria-selected="false">विचार</a>
                        <a class="nav-link"  routerLink="/path/sutrapath/vicharMalika"  id="v-pills-messages-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages"
                            aria-selected="false">विचार मालिका</a>
                    </div>
                </div>
                <div class="col-9"> <app-accordion [items]="sutras" [loaderVisable]="isProgress"></app-accordion></div>
            </div>
            <div *ngIf="!isSutraPath"> <app-accordion [items]="sutras" [loaderVisable]="isProgress"></app-accordion></div>

        </div>
    </section>
</main>